import React, { useEffect, useState } from "react";
import Dashboard from "../../layouts/Dashboard";
import { Badge, Card, Modal, Pagination } from "antd";
import { CheckCircleOutlined, ClockCircleOutlined } from "@ant-design/icons";
import $ from "jquery";
import axios from "../../services/axios";
import isConsultant from "../../services/isConsultant";
import { NavLink as Link } from "react-router-dom";
import SearchBox from "./SearchBox";
import DateFilter from "./DateFilter";
import moment from "moment";
import ReactLoading from "react-loading";

var dt = require("datatables.net");
require("datatables.net-bs4");
$.DataTable = dt;

function ConsultantDashboard() {
  const [load, setLoad] = useState(false);
  const [candidates, setCandidates] = useState([]);
  const [dataCount, setDataCount] = useState({});
  const [isModalVisibleFeedback, setIsModalVisibleFeedback] = useState(false);
  const [candidateInformation, setCandidateInformation] = useState();
  const [current, setCurrent] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [defaultDate, setDefaultDate] = useState([]);
  const [csvData, setCsvData] = useState([])

  const consultantName = localStorage.getItem("consultant.name");

  const handleCancelFeedback = () => {
    setIsModalVisibleFeedback(false);
  };

  async function mouseClick(candidate) {
    setIsModalVisibleFeedback(true);
    const candidateId = candidate;

    try {
      const { data } = await axios.get("/consultant/candidate/" + candidateId, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("consultant.token")}`,
        },
      });
      setCandidateInformation(data);
      // setBulkInfo(data);
    } catch (e) {
      console.error(e);
    }
  }

  useEffect(() => {
    fetchData(searchText);
    consultantDataCount(searchText);
    csvDownload()
  }, [consultantName, current, defaultDate]);

  function fetchData(searchText) {
    setLoad(true);
    axios
      .get(
        `/consultant?page=${current}&limit=10&consultantName=${consultantName}&search=${searchText}&startDate=${
          defaultDate[0] ? defaultDate[0] : ""
        }&endDate=${defaultDate[1] ? defaultDate[1] : ""}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("consultant.token")}`,
          },
        }
      )
      .then((res) => {
        const data = res.data;
        setCandidates(data);
        setLoad(false);
      })
      .catch((err) => {
        setLoad(false);
      });
  }

  function csvDownload(){
    axios
      .get(
        `/consultants/csvAllCandidates?consultantName=${consultantName}&startDate=${
          defaultDate[0] ? defaultDate[0] : ""
        }&endDate=${defaultDate[1] ? defaultDate[1] : ""}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("consultant.token")}`,
          },
        }
      )
      .then((res) => {
        const data = res.data;
        setCsvData(data);
        // setLoad(false);
      })
      .catch((err) => {
        // setLoad(false);
      });
  }

  function consultantDataCount(searchText) {
    setLoad(true);
    axios
      .get(
        `/consultant/Count?consultancyName=${consultantName}&search=${searchText}&startDate=${
          defaultDate[0] ? defaultDate[0] : ""
        }&endDate=${defaultDate[1] ? defaultDate[1] : ""}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("consultant.token")}`,
          },
        }
      )
      .then((res) => {
        setDataCount(res.data);
        setLoad(false);
      })
      .catch((err) => {
        setLoad(false);
      });
  }

  // Pagination event-handeler
  const handlePagination = (e) => {
    setCurrent(e);
  };

  // IST Time standard

  // function formatDate(d) {
  //     let date = new Date(d);
  //     var dd = date.getDate();
  //     var mm = date.getMonth() + 1;
  //     var yyyy = date.getFullYear();
  //     var hours = date.getHours();
  //     var minutes = date.getMinutes();
  //     var seconds = date.getSeconds();
  //     if (dd < 10) {
  //       dd = "0" + dd;
  //     }
  //     if (mm < 10) {
  //       mm = "0" + mm;
  //     }
  //     return (d =
  //       dd + "/" + mm + "/" + yyyy + " " + hours + ":" + minutes + ":" + seconds);
  //   }

  function formatDate(date) {
    const inputDate = date;
    // const outputFormat = 'DD/MM/YYYY HH:mm:ss';
    const outputFormat = "DD/MM/YYYY";
    const formattedDate = moment.utc(inputDate).format(outputFormat);
    return formattedDate;
  }

  return (
    <div>
      {load && (
        <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
      )}
      {isConsultant() && (
        <Dashboard
          setSearchText={setSearchText}
          setCurrent={setCurrent}
          fetchData={fetchData}
          consultantDataCount={consultantDataCount}
          setDefaultDate={setDefaultDate}
          csvData={csvData}
        >
          <div className="row">
            <div className="col-md-5 col-sm-12">
              <h1>Dashboard</h1>
            </div>
            {/* <div className="col-md-4 col-sm-12">
              <DateFilter
                setDefaultDate={setDefaultDate}
                setCurrent={setCurrent}
              />
            </div>
            <div className="col-md-3 col-sm-12">
              <SearchBox
                setSearchText={setSearchText}
                fetchData={fetchData}
                consultantDataCount={consultantDataCount}
                setCurrent={setCurrent}
              />
            </div> */}
          </div>

          <div className="row mt-2">
            <div className="col-md-3 col-sm-12">
              <div className="card dash-card p-3">
                <p className="heading">Total</p>
                <div className="d-flex flex-row align-items-center justify-content-between">
                  <h2>{dataCount?.totalCandidates}</h2>
                  <i className="fa fa-users icon"></i>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-12">
              <div className="card dash-card p-3">
                <p className="heading">New</p>
                <div className="d-flex flex-row align-items-center justify-content-between">
                  <h2>{dataCount?.newApplication}</h2>
                  <Link className="nav-link p-0" to="/newcandidates" exact>
                    <i className="fa fa-user icon"></i>
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-12">
              <div className="card dash-card p-3">
                <p className="heading">Selected</p>
                <div className="d-flex flex-row align-items-center justify-content-between">
                  <h2>{dataCount?.completedInterviews}</h2>
                  <Link className="nav-link p-0" to="/selectedcandidates" exact>
                    <i className="fa fa-group icon"></i>
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-12">
              <div className="card dash-card p-3">
                <p className="heading">Joined</p>
                <div className="d-flex flex-row align-items-center justify-content-between">
                  <h2>{dataCount?.joinedCandidates}</h2>
                  <Link className="nav-link p-0" to="/joinedcandidates" exact>
                    <i className="fa fa-user-plus icon"></i>
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-12 mt-3">
              <div className="card dash-card p-3">
                <p className="heading">Pending</p>
                <div className="d-flex flex-row align-items-center justify-content-between">
                  <h2>{dataCount?.pendingCount}</h2>
                  <Link className="nav-link p-0" to="/pendingcandidates" exact>
                    <i className="fa fa-clock-o icon"></i>
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-12 mt-3">
              <div className="card dash-card p-3">
                <p className="heading">Not Selected</p>
                <div className="d-flex flex-row align-items-center justify-content-between">
                  <h2>{dataCount?.totalRejected}</h2>
                  <Link className="nav-link p-0" to="/rejectedcandidates" exact>
                    <i className="fas fa-user-times icon"></i>
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-12 mt-3">
              <div className="card dash-card p-3">
                <p className="heading">Inactive</p>
                <div className="d-flex flex-row align-items-center justify-content-between">
                  <h2>{dataCount?.inactiveCount}</h2>
                  <Link className="nav-link p-0" to="/inactivecandidate" exact>
                    <i className="fa fa-clock-o icon"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="row my-lg-3 mt-1">
            <div className="col-12">
              <Card
                className="card rounded-0 border m-1 p-2"
                title={consultantName}
              >
                <div className="table-responsive">
                  <table id="table-datatable" className="table bg-white">
                    <thead className="table-head">
                      <tr>
                        <td className="table-column-head">Name</td>
                        <td className="table-column-head">Email</td>
                        <td className="table-column-head">Phone</td>
                        <td className="table-column-head">Date Applied</td>
                        <td className="table-column-head">Interview Status</td>
                        <td className="table-column-head">View</td>
                      </tr>
                    </thead>
                    <tbody>
                      {candidates?.map((ele, k) => {
                        return (
                          <tr key={k}>
                            <td>{ele.name}</td>
                            <td>{ele.email}</td>
                            <td>{ele.mobileNo}</td>
                            <td>{formatDate(ele.createdAt)}</td>
                            <td>
                              {ele.L4_Status !== ""
                                ? `L4_Status: ${ele.L4_Status}`
                                : ele.L3_Status !== ""
                                ? `L3_Status: ${ele.L3_Status}`
                                : ele.L2_Status !== ""
                                ? `L2_Status: ${ele.L2_Status}`
                                : ele.L1_Status !== ""
                                ? `L1_Status: ${ele.L1_Status}`
                                : `Application Received`}
                            </td>
                            <td
                              onClick={() => mouseClick(ele._id)}
                              // className="ml-1 d-inline"
                              className="d-flex align-items-center justify-content-center"
                            >
                              <i class="fa fa-eye cursor-pointer"></i>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                  <Modal
                    className="request-modal"
                    title={<h5 className="font-weight-bold mb-0">Status</h5>}
                    visible={isModalVisibleFeedback}
                    footer={false}
                    onCancel={handleCancelFeedback}
                  >
                    <div className="mb-4 mt-0 card p-2">
                      <h4 className="hr-ratings-title m-0 pl-1">
                        {"Personal Information"}
                      </h4>
                      <table className="table table-candidate mt-1">
                        <tbody>
                          <tr>
                            <td>Name:</td>
                            <td>{candidateInformation?.name}</td>
                          </tr>
                          <tr>
                            <td>Email:</td>
                            <td>{candidateInformation?.email}</td>
                          </tr>
                          <tr>
                            <td>Phone:</td>
                            <td>{candidateInformation?.mobileNo}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div className="mb-4 mt-0 card p-2">
                      <h4 className="hr-ratings-title m-0 pl-1">
                        {"Interview Status"}
                      </h4>
                      <table className="table table-candidate mt-1">
                        <tbody>
                          <tr>
                            <td>L1 Round Status:</td>
                            <td>{candidateInformation?.L1_Status}</td>
                          </tr>
                          <tr>
                            <td>L2 Round Status:</td>
                            <td>{candidateInformation?.L2_Status}</td>
                          </tr>
                          <tr>
                            <td>L3 Round Status:</td>
                            <td>{candidateInformation?.L3_Status}</td>
                          </tr>
                          <tr>
                            <td>Client Round Status:</td>
                            <td>{candidateInformation?.L4_Status}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </Modal>
                </div>

                <Pagination
                  current={current}
                  onChange={handlePagination}
                  total={dataCount.totalCandidates}
                  showSizeChanger={false}
                  className="mt-2 pl-2"
                />
              </Card>
            </div>
          </div>
        </Dashboard>
      )}
    </div>
  );
}

export default ConsultantDashboard;
